import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { ref: "facebookModal" }
const _hoisted_2 = {
  key: 0,
  class: "facebook-modal__container",
  id: "facebook-a"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "facebook-modal__text" }, "Kövess minket, és értesülj a friss hírekről a Facebookon is!", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Követem ")
const _hoisted_5 = {
  key: 1,
  class: "facebook-modal__container",
  id: "facebook-b"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "facebook-modal__text" }, "Kövess minket, és értesülj a friss hírekről a Facebookon is!", -1)
const _hoisted_7 = ["src", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_facebook_full = _resolveComponent("facebook-full")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isAvailable && _ctx.hasShown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["facebook-modal", `facebook-modal--${_ctx.version}`])
        }, [
          (_ctx.version == 'a')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("a", {
                  href: "https://www.facebook.com/rtlponthu",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click('a'))),
                  target: "_blank",
                  class: "facebook-follow__button facebook-modal__trigger"
                }, [
                  _createVNode(_component_facebook_full),
                  _hoisted_4
                ]),
                _createVNode(_component_Close, {
                  class: "close facebook-modal__close facebook-modal__close-a",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.version == 'b')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Close, {
                  class: "close facebook-modal__close facebook-modal__close-b",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
                }),
                _hoisted_6,
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.click())),
                  class: "facebook-modal__iframe-cont"
                }, [
                  _createElementVNode("iframe", {
                    class: "facebook-modal__iframe facebook-modal__trigger",
                    src: _ctx.fbPluginSrc,
                    width: _ctx.iframeWidth + 'px',
                    height: "130px",
                    style: {"border":"none","overflow":"hidden"},
                    scrolling: "no",
                    frameborder: "0",
                    allowfullscreen: "false",
                    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  }, null, 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 512))
}